import React, { useState } from 'react'
import AdminAppBar from '../../adminComponents/AdminAppBar'
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom'
import Gift from './Gift'
import SpinWheelForm from './SpinWheelForm'
import SpinWheelService from '../../Services/SpinWheelService'
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import { ToastContainer } from 'react-toastify'
import CustomHeading from '../../common/CustomHeading'


const SpinWheelCreation = () => {
  const [spObj, setSpObj]= useState();
  const [gifts, setgifts]= useState();

    const navigate = useNavigate()
    const location = useLocation()

console.log(gifts)
const userObj = JSON.parse(localStorage.getItem("userData"));
const userUid = userObj?.user?.uid;


const createdUserDocId= userUid;
const modifiedUserDocId = userUid
    const handleCreate =async()=>{
      if(!gifts || !spObj){
        showErrorToast("All Fields are mandatory")
        return false;
      }

      try{
  const response = await SpinWheelService.createSpinwheel(spObj,gifts,createdUserDocId, modifiedUserDocId)
  console.log(response.data)
navigate(-1, {state: {message: "Spin Wheel created succussfully"}})
}catch(error){
  showErrorToast(error.response.data)
  console.log(error.response.data)
}
    }
    const handleBack=()=>{
navigate(-1)
    }
const GiftData =(gifts)=>{
  setgifts(gifts)
}
const spData =(sp)=>{
  setSpObj(sp)
}
  return (
    <div className=' bg-appGrayBackground pb-10 '>
      <AdminAppBar/>
<ToastContainer/>
      <div className="pt-24 px-20 xl:px-6 relative flex justify-between gap-5">
       <CustomHeading title={"New Spin Wheel"} isIcon={true} />
        <div>
          <button
            onClick={handleCreate}
            className=" whitespace-nowrap bg-customGreen rounded-lg p-1 px-5 w-32 text-lg text-white h-10 text-center"
          >
            Create
          </button>
        </div>






      </div>
      <div className='mt-5 mx-10 grid grid-cols-12 gap-10 '>
        <div className='col-span-8 bg-white rounded-lg px-5 py-5 ' >

        <Gift giftsDetail={GiftData} />
        </div>
        <div className='col-span-4 bg-white rounded-lg px-5'>
            <SpinWheelForm spDetail={spData} />
        </div>
    </div>
    </div>
  )
}

export default SpinWheelCreation
